/**
 * Leitura da env de produto, sem dependências, para poder ser importada
 * tanto por utils/constants quanto por config/produto sem import circular.
 */
export type Produto = 'PREMIO_BB' | 'PREMIO_ELBB';

const PRODUTOS_VALIDOS: Produto[] = ['PREMIO_BB', 'PREMIO_ELBB'];

export function getProduto(): Produto {
  const env = process.env.REACT_APP_PRODUTO;
  if (!env || !PRODUTOS_VALIDOS.includes(env as Produto)) {
    if (env) {
      console.warn(
        `[getProduto] REACT_APP_PRODUTO="${env}" não é um valor válido. Usando PREMIO_BB.`
      );
    }
    return 'PREMIO_BB';
  }
  return env as Produto;
}
